<template>
    <div style="box-sizing: border-box;padding: 20px 0;">
        <div class="bk">
            <div class="flx alc cursor" style="height: 100%;" @click="bobk">
                <i class="el-icon-arrow-left" style="margin-right: 8px;"></i> 返回
            </div>
        </div>
        <div class="fs">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="num1 > 0?`待审核·${num1}` : '待审核'" name="1"></el-tab-pane>
                <el-tab-pane :label="num2 > 0?`已过审·${num2}` : '已过审'" name="2"></el-tab-pane>
                <el-tab-pane :label="num3 > 0?`未过审·${num3}` : '未过审'" name="3"></el-tab-pane>
            </el-tabs>
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column  :selectable="checkSelectable" type="selection" width="55">
                </el-table-column>
                <el-table-column label="日期" width="120">
                    <template slot-scope="scope">{{ scope.row.createtime_text }}</template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" width="120">
                </el-table-column>
                <el-table-column prop="name" label="审核状态" width="120">
                    <template slot-scope="scope">{{ scope.row.check_status == 0?'未审核' : scope.row.check_status == 1?'审核中' : scope.row.check_status == 2?'已通过' : '已驳回'}}</template>
                </el-table-column>
                <el-table-column prop="company_name" label="企业名称" width="" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="position_name" label="岗位职务" width="180" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="industry_name" label="行业类型" width="180" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="address" label="所在地区" width="180" show-overflow-tooltip>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="160">
                    <template slot-scope="scope" v-if="activeName == '1'">
                        <el-button @click="checkPerson(scope.row)" type="text" size="small">查看</el-button>
                        <el-button v-if="scope.row.check_status == 1 || scope.row.check_status == 0 " @click="refuseac(scope.row)" type="text" size="small"
                            style="color: #E4393C;">拒绝</el-button>
                        <el-button v-if="scope.row.check_status == 1 || scope.row.check_status == 0 " @click="passac(scope.row)" type="text" size="small"
                            style="color: #4CC864;">通过</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
                <el-button type="success" @click="passItems">批量通过</el-button>
                <el-button type="danger" @click="refuseItems">批量拒绝</el-button>
                <el-button type="primary" @click="daochu">导出参与者名单</el-button>
            </div>
            <div style="padding: 20px 0;">
                <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                    :total="totals">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="拒绝理由" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <!-- 多行文本框 -->
            <el-input v-model="textareaVal" type="textarea" :rows="6" placeholder="请输入拒绝理由" resize="none" maxlength="500"
                show-word-limit></el-input>

            <!-- 底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false,textareaVal = ''">取消</el-button>
                <el-button type="primary" @click="submit">确定提交</el-button>
            </span>
        </el-dialog>
        <el-dialog title="拒绝理由" :visible.sync="dialogVisible1" width="30%" :before-close="handleClose1">
            <!-- 多行文本框 -->
            <el-input v-model="textareaVal1" type="textarea" :rows="6" placeholder="请输入拒绝理由" resize="none" maxlength="500"
                show-word-limit></el-input>
        
            <!-- 底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible1 = false,textareaVal1 = ''">取消</el-button>
                <el-button type="primary" @click="submit1">确定提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        signpeople,
        shenAc
    } from "@/api/index.js"
    export default {
        data() {
            return {
                totals: 0,
                id: "",
                page: 1,
                size: 20,
                activeName: "1",
                tableData: [],
                multipleSelection: [],
                num1: 0,
                num2: 0,
                num3: 0,
                dialogVisible: false,
                dialogVisible1:false,
                selid: {},
                textareaVal: "",
                selids:"",
                textareaVal1:""
            }
        },
        created() {
            this.id = this.$route.query.id
            this.getList()
        },
        methods: {
             checkSelectable(row) {
                // 示例：status=1 的行禁止勾选
                if(row.check_status == 1 || row.check_status == 0){
                  return true
                }
                return false
              },
            daochu(){
                let that = this
                window.open(that.$baseUrl + '/api/Index/activity_channel_download_excel?source=activity&activity_id=' + this.$route.query.id)
            },
            // 关闭弹窗回调
            handleClose() {
                this.dialogVisible = false
                this.textareaVal = '' // 关闭清空内容
            },
            handleClose1() {
                this.dialogVisible1 = false
                this.textareaVal1 = '' // 关闭清空内容
            },
            refuseItems(){
                let that = this 
                console.log("refuse")
                let atr = []
                that.multipleSelection.forEach((v,i) => {
                    atr.push(v.id)
                })
                if(atr.length == 0){
                    that.$message({
                        type: 'warning',
                        message: "请至少选择1个用户"
                    });
                    return
                }
                that.selids = atr.join()
                that.dialogVisible1 = true
            },
            passItems(){
                let that = this 
                let atr = []
                that.multipleSelection.forEach((v,i) => {
                    atr.push(v.id)
                })
                if(atr.length == 0){
                    that.$message({
                        type: 'warning',
                        message: "请至少选择1个用户"
                    });
                    return
                }
               let data = {}
               data.ids = atr.join()
               data.type = 2
               that.$confirm('确定要通过'+atr.length+'个用户的申请吗?', ' ', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
               }).then(() => {
                   shenAc(data).then((res) => {
                       console.log(res)
                       if (res.code == 1) {
                           that.$message({
                               type: 'success',
                               message: res.msg
                           });
                           that.getList()
                       } else {
                           that.$message({
                               type: 'error',
                               message: res.msg
                           });
                       }
                   })
               }).catch(() => {
               
               });
            },
            submit() {
                let that = this
                let data = {}
                data.ids = that.selid.id
                data.type = 3
                data.check_remark = that.textareaVal
                shenAc(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.$message({
                            type: 'success',
                            message: res.msg
                        });
                        that.getList()
                        that.dialogVisible = false
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            },
            submit1(){
                let that = this
                let data = {}
                data.ids = that.selids
                data.type = 3
                data.check_remark = that.textareaVal1
                shenAc(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.$message({
                            type: 'success',
                            message: res.msg
                        });
                        that.getList()
                        that.dialogVisible1 = false
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            },
            refuseac(e) {
                let that = this
                that.selid = e
                that.dialogVisible = true
            },
            passac(e) {
                let that = this
                let data = {}
                data.ids = e.id
                data.type = 2
                that.$confirm('确定要通过该用户的申请吗?', ' ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    shenAc(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            checkPerson(e) {
                console.log(e)
                this.$router.push({
                    path: '/AcInfo', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            getList() {
                let that = this
                let data = {}
                data.check_status = that.activeName
                data.page = that.page
                data.size = that.size
                data.id = that.id
                signpeople(data).then((res) => {
                    if (res.code == 1) {
                        that.totals = res.data.list.total
                        that.tableData = res.data.list.data
                        that.num1 = res.data.num1
                        that.num2 = res.data.num2
                        that.num3 = res.data.num3
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            },
            handleCurrentChange(e) {
                console.log(e)
            },
            bobk() {
                this.$router.go(-1)
            },
            handleClick(e) {
                console.log(this.activeName)
                this.page = 1
                this.getList()
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                console.log(val)
                this.multipleSelection = val;
            }
        }
    }
</script>

<style scoped>
    .fs {
        width: 1460px;
        background-color: #fff;
        margin: 0 auto;
    }

    .bk {
        width: 1460px;
        height: 68px;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 0 30px;
        margin: 0 auto 20px;
        font-size: 14px;
        color: #000000;
    }
</style>